module.exports = __webpack_public_path__ + "img/footprint_bruised_purple.6fa4d006.png";